const authenticationIndicator = [0, 1, 2];

export default authenticationIndicator;
